export default __webpack_public_path__ + "static/media/ico-whats.f807cada.svg";